import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart"
import { EventoEmpresaTipo } from "@/types/dashboard"
import { Bar, BarChart, CartesianGrid, XAxis, YAxis, Cell } from "recharts"
import { useIsMobile } from "@/hooks/use-mobile"

import { ChartConfig } from "@/components/ui/chart"

export default function ParticipacoesPorTipoChart({ data }: { data: EventoEmpresaTipo[] }) {
  const isMobile = useIsMobile()
  const chartData = data
  const COLORS = ["#60a5fa", "#a78bfa", "#4ade80", "#facc15"]

  const chartConfig = chartData.reduce(
    (acc, item, index) => {
      const key = item.gr_descricao
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/ /g, "_")
      acc[key] = {
        label: item.gr_descricao,
        color: COLORS[index % COLORS.length],
      }
      return acc
    },
    { total: { label: "Total" } } as ChartConfig
  )

  return (
    <Card className="flex flex-1 basis-[700px] flex-col">
      <CardHeader>
        <CardTitle>Participações por Tipo</CardTitle>
      </CardHeader>
      <CardContent className="flex-1 pb-0">
        <ChartContainer
          config={chartConfig}
          className={`aspect-square w-full ${!isMobile ? "max-h-[140px]" : "max-h-[300px]"}`}
        >
          <BarChart
            accessibilityLayer
            data={chartData}
            layout={!isMobile ? "vertical" : "horizontal"}
            margin={{
              left: !isMobile ? 50 : 0,
              top: 20,
            }}
          >
            <CartesianGrid
              vertical={!isMobile}
              horizontal={!!isMobile}
            />

            <XAxis
              dataKey={!isMobile ? "total" : "gr_descricao"}
              type={!isMobile ? "number" : "category"}
              hide={!isMobile}
              tickLine={false}
              tickMargin={10}
              axisLine={false}
            />
            <YAxis
              dataKey={!isMobile ? "gr_descricao" : "total"}
              type={!isMobile ? "category" : "number"}
              hide={isMobile}
              tickLine={false}
              tickMargin={10}
              axisLine={false}
            />

            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent />}
            />
            <Bar
              dataKey="total"
              radius={!isMobile ? [0, 5, 5, 0] : [5, 5, 0, 0]}
              barSize={!isMobile ? 100 : 40}
            >
              {chartData.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Bar>
          </BarChart>
        </ChartContainer>

        {/* Legenda fixa abaixo */}
        <div className="flex flex-wrap items-center justify-center gap-4 p-4">
          {Object.keys(chartConfig)
            .filter((key) => key !== "total")
            .map((key) => (
              <div
                key={key}
                className="flex items-center gap-2"
              >
                <div
                  className="size-2 shrink-0 rounded-[2px]"
                  style={{
                    backgroundColor: chartConfig[key as keyof typeof chartConfig]?.color,
                  }}
                />
                <span className="text-sm text-muted-foreground">
                  {chartConfig[key as keyof typeof chartConfig]?.label}
                </span>
              </div>
            ))}
        </div>
      </CardContent>
    </Card>
  )
}
